// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2NtF8","resendInfoText":"OnGoingPaymentBox_resendInfoText__2pMZp"};